import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'react-bootstrap';
import { 
  RiProductHuntLine, 
  RiShoppingBag3Line, 
  RiCloseCircleLine 
} from 'react-icons/ri';
import { MdLocalShipping } from 'react-icons/md';
import { TbTruckReturn } from 'react-icons/tb';
import Loader from '../../component/loader';
import NotApprove from '../../component/notApprove';
import axios from 'axios';
import Cookies from 'js-cookie';
import { decrpt } from '../../component/encryption';
import RegistrationStatus from '../../context/RegistrationStatus';

function Dashboard() {
  const [loader, setLoader] = useState(false);
  const [countData, setCountData] = useState(null);
  const [orderListData, setOrderListData] = useState([]);
  const [returnListData, setReturnListData] = useState([]);
  const Status = useContext(RegistrationStatus);

  const getOrderStatusBadge = (status) => {
    const s = Number(status);
    switch (s) {
      case 1:
        return <Badge bg="primary">New Order</Badge>;
      case 2:
        return <Badge bg="info">Accepted</Badge>;
      case 3:
        return <Badge bg="warning" text="dark">Dispatched</Badge>;
      case 4:
        return <Badge bg="secondary">Out For Delivery</Badge>;
      case 5:
        return <Badge bg="success">Delivered</Badge>;
      case 6:
      case 7:
      case 8:
        return <Badge bg="danger">Cancelled</Badge>;
      default:
        return <Badge bg="secondary">Pending</Badge>;
    }
  };

  const getReturnStatusBadge = (status, stageText) => {
    const s = String(status);
    switch (s) {
      case '1':
        return <Badge bg="primary">{stageText || 'Requested'}</Badge>;
      case '2':
        return <Badge bg="info">{stageText || 'Approved'}</Badge>;
      case '3':
        return <Badge bg="warning" text="dark">{stageText || 'Picked Up'}</Badge>;
      case '4':
        return <Badge bg="success">{stageText || 'Refunded'}</Badge>;
      case '5':
        return <Badge bg="danger">{stageText || 'Denied'}</Badge>;
      default:
        return <Badge bg="secondary">{stageText || 'Pending'}</Badge>;
    }
  };

  const appLoad = async () => {
    setLoader(true);
    try {
      const rawToken = Cookies.get('s_l');
      if (rawToken) {
        const token = decrpt(rawToken);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
      const response = await axios.get(`/seller/dashboard`);
      if (response.data && response.data.success) {
        if (response.data.registration_status !== undefined) {
          Status.setProfile(response.data.registration_status);
        }
        setCountData(response.data.counts || {});
        setOrderListData(response.data.data_list?.order_list || []);
        setReturnListData(response.data.data_list?.return_list || []);
      }
    } catch (error) {
      console.error('Seller dashboard load error:', error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    appLoad();
  }, []);

  return (
    <div className="responsive-xs responsive-sm p-2">
      {Status?.profile?.registration_status && Status.profile.registration_status === 5 ? (
        <NotApprove />
      ) : (
        <>
          {loader && <Loader />}

          {/* KPI Statistic Cards (5 Cards) */}
          <div className="row g-3 my-2">
            {/* Total Orders */}
            <div className="col-12 col-sm-6 col-md-4 col-xl">
              <div className="card h-100 p-3 shadow-sm border-0" style={{ backgroundColor: "#ffffff" }}>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <small className="text-muted fw-bold text-uppercase d-block" style={{ fontSize: "11px" }}>Total Orders</small>
                    <h4 className="mb-0 fw-bold text-primary" style={{ fontSize: "22px" }}>
                      {countData?.total_orders !== undefined ? countData.total_orders : (countData?.total_new_orders || 0)}
                    </h4>
                    <small className="text-muted" style={{ fontSize: "11px" }}>
                      {countData?.total_new_orders || 0} New Orders
                    </small>
                  </div>
                  <div className="p-2 rounded-circle bg-light text-primary" style={{ fontSize: "24px" }}>
                    <RiShoppingBag3Line />
                  </div>
                </div>
                <div className="mt-2 pt-2 border-top">
                  <Link to="order/list" className="link-item fw-semibold" style={{ fontSize: "11px" }}>See Orders &rarr;</Link>
                </div>
              </div>
            </div>

            {/* Total Products */}
            <div className="col-12 col-sm-6 col-md-4 col-xl">
              <div className="card h-100 p-3 shadow-sm border-0" style={{ backgroundColor: "#ffffff" }}>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <small className="text-muted fw-bold text-uppercase d-block" style={{ fontSize: "11px" }}>Total Products</small>
                    <h4 className="mb-0 fw-bold text-warning" style={{ fontSize: "22px" }}>
                      {countData?.total_products || 0}
                    </h4>
                    <small className="text-muted" style={{ fontSize: "11px" }}>
                      {countData?.active_products || 0} Active
                    </small>
                  </div>
                  <div className="p-2 rounded-circle bg-light text-warning" style={{ fontSize: "24px" }}>
                    <RiProductHuntLine />
                  </div>
                </div>
                <div className="mt-2 pt-2 border-top">
                  <Link to="product" className="link-item fw-semibold" style={{ fontSize: "11px" }}>Manage Products &rarr;</Link>
                </div>
              </div>
            </div>

            {/* Delivered Orders */}
            <div className="col-12 col-sm-6 col-md-4 col-xl">
              <div className="card h-100 p-3 shadow-sm border-0" style={{ backgroundColor: "#ffffff" }}>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <small className="text-muted fw-bold text-uppercase d-block" style={{ fontSize: "11px" }}>Delivered</small>
                    <h4 className="mb-0 fw-bold text-success" style={{ fontSize: "22px" }}>
                      {countData?.delivered_orders || 0}
                    </h4>
                    <small className="text-muted" style={{ fontSize: "11px" }}>
                      Completed Deliveries
                    </small>
                  </div>
                  <div className="p-2 rounded-circle bg-light text-success" style={{ fontSize: "24px" }}>
                    <MdLocalShipping />
                  </div>
                </div>
                <div className="mt-2 pt-2 border-top">
                  <Link to="order/list" className="link-item fw-semibold" style={{ fontSize: "11px" }}>Delivered List &rarr;</Link>
                </div>
              </div>
            </div>

            {/* Total Cancelled */}
            <div className="col-12 col-sm-6 col-md-4 col-xl">
              <div className="card h-100 p-3 shadow-sm border-0" style={{ backgroundColor: "#ffffff" }}>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <small className="text-muted fw-bold text-uppercase d-block" style={{ fontSize: "11px" }}>Cancelled</small>
                    <h4 className="mb-0 fw-bold text-secondary" style={{ fontSize: "22px" }}>
                      {countData?.total_cancelled_orders || 0}
                    </h4>
                    <small className="text-muted" style={{ fontSize: "11px" }}>
                      Cancelled Orders
                    </small>
                  </div>
                  <div className="p-2 rounded-circle bg-light text-secondary" style={{ fontSize: "24px" }}>
                    <RiCloseCircleLine />
                  </div>
                </div>
                <div className="mt-2 pt-2 border-top">
                  <Link to="order/list" className="link-item fw-semibold" style={{ fontSize: "11px" }}>See Cancelled &rarr;</Link>
                </div>
              </div>
            </div>

            {/* Returns */}
            <div className="col-12 col-sm-6 col-md-4 col-xl">
              <div className="card h-100 p-3 shadow-sm border-0" style={{ backgroundColor: "#ffffff" }}>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <small className="text-muted fw-bold text-uppercase d-block" style={{ fontSize: "11px" }}>Returns</small>
                    <h4 className="mb-0 fw-bold text-danger" style={{ fontSize: "22px" }}>
                      {countData?.total_returns || 0}
                    </h4>
                    <small className="text-muted" style={{ fontSize: "11px" }}>
                      Return Requests
                    </small>
                  </div>
                  <div className="p-2 rounded-circle bg-light text-danger" style={{ fontSize: "24px" }}>
                    <TbTruckReturn />
                  </div>
                </div>
                <div className="mt-2 pt-2 border-top">
                  <Link to="order/returnOrderList" className="link-item fw-semibold" style={{ fontSize: "11px" }}>Check Returns &rarr;</Link>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Orders & Returns Row (Side by Side - Equal 50% Width) */}
          <div className="row g-3 my-2">
            {/* Recent Orders (Left) */}
            <div className="col-12 col-lg-6">
              <div className="card p-3 shadow-sm bg-white h-100">
                <div className="card-title d-flex align-items-center justify-content-between pb-2 mb-3">
                  <h5 className="mb-0">
                    <RiShoppingBag3Line className="me-2 text-primary" /> Recent Orders
                  </h5>
                  <Link to="order/list" className="btn btn-xs btn-warning fw-semibold">
                    View All Orders
                  </Link>
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-hover mb-0">
                    <thead>
                      <tr>
                        <th style={{ width: '80px' }}>Order ID</th>
                        <th>Buyer Name</th>
                        <th>Amount</th>
                        <th>Payment</th>
                        <th>Order Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderListData && orderListData.length > 0 ? (
                        orderListData.map((item, index) => {
                          const orderStatus = item.order_status !== undefined ? item.order_status : item.status;
                          const amount = Number(item.overall_price || item.total_price || 0);
                          return (
                            <tr key={item.id || index}>
                              <td><strong>{item.order_uuid || `#${item.id}`}</strong></td>
                              <td>{item.user_name || 'Customer'}</td>
                              <td>
                                <strong className="text-success">
                                  ₹{amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </strong>
                              </td>
                              <td>
                                <span className={`badge ${item.payment_type === 'Online' ? 'bg-primary' : 'bg-secondary'}`}>
                                  {item.payment_type || 'COD'}
                                </span>
                              </td>
                              <td>{item.order_date || 'N/A'}</td>
                              <td>{getOrderStatusBadge(orderStatus)}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center py-3 text-muted">No orders found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Recent Returns (Right) */}
            <div className="col-12 col-lg-6">
              <div className="card p-3 shadow-sm bg-white h-100">
                <div className="card-title d-flex align-items-center justify-content-between pb-2 mb-3">
                  <h5 className="mb-0">
                    <TbTruckReturn className="me-2 text-danger" /> Recent Returns
                  </h5>
                  <Link to="order/returnOrderList" className="btn btn-xs btn-warning fw-semibold">
                    View All Returns
                  </Link>
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-hover mb-0">
                    <thead>
                      <tr>
                        <th style={{ width: '70px' }}>Return ID</th>
                        <th>Order</th>
                        <th>Customer</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {returnListData && returnListData.length > 0 ? (
                        returnListData.map((item, index) => {
                          const amount = Number(item.amount || 0);
                          return (
                            <tr key={item.id || index}>
                              <td><strong>#{item.id}</strong></td>
                              <td>
                                <div className="fw-semibold">{item.order_uuid || `#${item.order_id}`}</div>
                              </td>
                              <td>{item.user_name || 'Customer'}</td>
                              <td>
                                <strong className="text-danger">
                                  ₹{amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </strong>
                              </td>
                              <td>{getReturnStatusBadge(item.status, item.stage_text)}</td>
                              <td>{item.created_at || 'N/A'}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center py-3 text-muted">No return requests found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Dashboard;
